import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function useFavorites() {
  const { user } = useAuth();
  const [favs, setFavs] = useState([]);
  const [follows, setFollows] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setFavs([]); setFollows([]); return; }
    try {
      const { data } = await api.get("/favorites/ids");
      setFavs(data.favorites);
      setFollows(data.follows);
    } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggleFav = async (bid) => {
    if (!user) { toast.error("Sign up to save favorites"); return; }
    try {
      const { data } = await api.post(`/favorites/${bid}`);
      setFavs((p) => (data.favorited ? [...p, bid] : p.filter((x) => x !== bid)));
      toast.success(data.favorited ? "Saved to favorites" : "Removed from favorites");
    } catch {}
  };

  const toggleFollow = async (bid) => {
    if (!user) { toast.error("Sign up to follow businesses"); return; }
    try {
      const { data } = await api.post(`/follows/${bid}`);
      setFollows((p) => (data.following ? [...p, bid] : p.filter((x) => x !== bid)));
      toast.success(data.following ? "Following" : "Unfollowed");
    } catch {}
  };

  return { favs, follows, toggleFav, toggleFollow, refresh };
}
